import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { MINUTES_TO_MILLIS } from "lopermut"
import { BackofficeCapabilityExecutionsAnalyticsResponseDataSchema, DataResponse } from "schema"
import { z } from "zod"

type Response = DataResponse<
  z.infer<typeof BackofficeCapabilityExecutionsAnalyticsResponseDataSchema>
>

type BackofficeCapabilityExecutionsAnalyticsQuery = {
  companyId?: string
  experiment?: string
  from: string
  activityFrom: string
  to: string
  page?: number
  total?: number
  status?: string
  reason?: string
  provider?: string
  capabilityIdentifier?: string
  action?: string
}

export const getBackofficeCapabilityExecutionsAnalyticsQuery = (
  query: BackofficeCapabilityExecutionsAnalyticsQuery,
) => {
  const params: Record<string, string> = {
    from: query.from,
    activityFrom: query.activityFrom,
    to: query.to,
  }

  if (query.companyId) params.companyId = query.companyId
  if (query.experiment) params.experiment = query.experiment
  if (query.page) params.page = String(query.page)
  if (query.total) params.total = String(query.total)
  if (query.status) params.status = query.status
  if (query.reason) params.reason = query.reason
  if (query.provider) params.provider = query.provider
  if (query.capabilityIdentifier) params.capabilityIdentifier = query.capabilityIdentifier
  if (query.action) params.action = query.action

  return queryOptions({
    queryKey: ["backoffice", "capabilityExecutions", query],
    staleTime: 10 * MINUTES_TO_MILLIS,
    queryFn: async () => {
      const { data } = await axios.get<Response>("/backoffice/capabilityExecutions/analytics", {
        params,
      })
      return data.data
    },
  })
}
